import React, { Component } from 'react';

class RijtijdSEH extends Component {
	//cy="736.47 is Maastricht
	state = {
			tooltip: { display: 'none', x: 0, y: 0, text: 'test' },
			data: {
				SEH1034: { "name":"AMSTERDAM"},
				SEH1061: { "name":"AMSTERDAM"},
				SEH1081: { "name":"AMSTERDAM"},
				SEH1091: { "name":"AMSTERDAM"},
				SEH1105: { "name":"AMSTERDAM ZUIDOOST"},
				SEH1213: { "name":"HILVERSUM"},
				SEH1261: { "name":"BLARICUM"},
				SEH1315: { "name":"ALMERE"},
				SEH1441: { "name":"PURMEREND"},
				SEH1502: { "name":"ZAANDAM"},
				SEH1624: { "name":"HOORN"},
				SEH1782: { "name":"DEN HELDER"},
				SEH1815: { "name":"ALKMAAR"},
				SEH1942: { "name":"BEVERWIJK"},
				SEH2035: { "name":"HAARLEM"},
				SEH2134: { "name":"'S-GRAVENHAGE"},
				SEH2597: { "name":"'S-GRAVENHAGE"},
				SEH2625: { "name":"DELFT"},
				SEH2725: { "name":"ZOETERMEER"},
				SEH2803: { "name":"GOUDA"},
				SEH2906: { "name":"CAPELLE A/D IJSSEL"},
				SEH3015: { "name":"ROTTERDAM"},
				SEH3045: { "name":"ROTTERDAM"},
				SEH3079: { "name":"ROTTERDAM"},
				SEH3083: { "name":"ROTTERDAM"},
				SEH3247: { "name":"DIRKSLAND"},
				SEH3318: { "name":"DORDRECHT"},
				SEH3435: { "name":"NIEUWEGEIN"},
				SEH3543: { "name":"UTRECHT"},
				SEH3582: { "name":"UTRECHT"},
				SEH3584: { "name":"UTRECHT"},
				SEH3813: { "name":"AMERSFOORT"},
				SEH3844: { "name":"HARDERWIJK"},
				SEH4002: { "name":"TIEL"},
				SEH4204: { "name":"GORINCHEM"},
				SEH4462: { "name":"GOES"},
				SEH4535: { "name":"TERNEUZEN"},
				SEH4624: { "name":"BERGEN OP ZOOM"},
				SEH4708: { "name":"ROOSENDAAL"},
				SEH4818: { "name":"BREDA"},
				SEH5022: { "name":"TILBURG"},
				SEH5223: { "name":"'S-HERTOGENBOSCH"},
				SEH5406: { "name":"UDEN"},
				SEH5504: { "name":"VELDHOVEN"},
				SEH5623: { "name":"EINDHOVEN"},
				SEH5664: { "name":"GELDROP"},
				SEH5707: { "name":"HELMOND"},
				SEH5835: { "name":"BEUGEN"},
				SEH5912: { "name":"VENLO"},
				SEH6001: { "name":"WEERT"},
				SEH6043: { "name":"ROERMOND"},
				SEH6162: { "name":"GELEEN"},
				SEH6229: { "name":"MAASTRICHT"},
				SEH6419: { "name":"HEERLEN"},
				SEH6525: { "name":"NIJMEGEN"},
				SEH6532: { "name":"NIJMEGEN"},
				SEH6716: { "name":"EDE GLD"},
				SEH6815: { "name":"ARNHEM"},
				SEH7009: { "name":"DOETINCHEM"},
				SEH7101: { "name":"WINTERSWIJK"},
				SEH7207: { "name":"ZUTPHEN"},
				SEH7334: { "name":"APELDOORN"},
				SEH7416: { "name":"DEVENTER"},
				SEH7512: { "name":"ENSCHEDE"},
				SEH7609: { "name":"ALMELO"},
				SEH7772: { "name":"HARDENBERG"},
				SEH7824: { "name":"EMMEN"},
				SEH7909: { "name":"HOOGEVEEN"},
				SEH7943: { "name":"MEPPEL"},
				SEH8025: { "name":"ZWOLLE"},
				SEH8441: { "name":"HEERENVEEN"},
				SEH8601: { "name":"SNEEK"},
				SEH8934: { "name":"LEEUWARDEN"},
				SEH9202: { "name":"DRACHTEN"},
				SEH9401: { "name":"ASSEN"},
				SEH9501: { "name":"STADSKANAAL"},
				SEH9679: { "name":"SCHEEMDA"},
				SEH9713: { "name":"GRONINGEN"},
				SEH9728: { "name":"GRONINGEN"}
			}
	}
	handleMouseMove = (evt) => {
		const { id } = evt.target;
		const { data }  = this.state;
		const wrapperX = this.wrapper.getBoundingClientRect().left;
		const wrapperY = this.wrapper.getBoundingClientRect().top;
		// const format = this.props.format ? this.props.format : value => value;
		const tooltip = data[id] ?
		{
			display: 'block',
			x: evt.clientX - wrapperX + 12,
			y: evt.clientY - wrapperY + 12,
			text: data[id].name
		} : { display: 'none', x: 0, y: 0, text: '' };
		this.setState({ tooltip })
	}
	handleMouseLeave = () => {
		const tooltip = { display: 'none', x: 0, y: 0, text: '' }
		this.setState({ tooltip })
	}
	render() {
		const { tooltip } = this.state;
		const tooltipStyle = {
			position: 'absolute',
			left: tooltip.x,
			top: tooltip.y,
			display: tooltip.display,
			backgroundColor: '#333',
			padding: '15px',
			borderRadius: '6px',
			color: '#fff',
			fontFamily: 'sans-serif',
			fontSize: '12px',
			height: 'auto',
			textAlign: 'center'
		}
		return (
			<div className="vis-rijtijd-seh svg-container" ref={(wrapper) => this.wrapper = wrapper }>
				<svg viewBox="0 -50 660 8300" preserveAspectRatio="xMidYMin meet">	
					<g className="waterkering">
						<path d="M283.29,174.29l44.59-44.6a8.39,8.39,0,0,1,5.12-2.12h1.79a8.33,8.33,0,0,0,5.12-2.12l21.23-21.24"/>
					</g>					
					<g className="aanrijgebieden">
						<g className="klasse2">
							<path d="M158.71,392.29l15.58-15.58h0c20.9-20.9,46.71-72.31,46.71-93.42v-74a10.83,10.83,0,0,1,2.75-6.64l10.07-10.07a10.83,10.83,0,0,0,2.75-6.65V162.61a3.91,3.91,0,0,1,3.89-3.9h7.79a3.91,3.91,0,0,1,3.89,3.9v7.78a3.91,3.91,0,0,0,3.9,3.9h7.78a10.78,10.78,0,0,0,6.64-2.76l10.13-10.15a10.7,10.7,0,0,1,6.64-2.74l7.73.05a3.94,3.94,0,0,1,3.9,3.92v38.93a3.9,3.9,0,0,0,3.89,3.89h23.36a3.9,3.9,0,0,1,3.89,3.89v23.36a10.83,10.83,0,0,1-2.75,6.64l-10.07,10.07a10.83,10.83,0,0,1-6.64,2.75h-7.79a3.9,3.9,0,0,0-3.89,3.9v54.5a3.9,3.9,0,0,0,3.89,3.89h7.79a10.83,10.83,0,0,0,6.64-2.75L374,254.9a10.83,10.83,0,0,1,6.65-2.76H404c2.15,0,2.66-1.24,1.14-2.75L395,239.32a10.77,10.77,0,0,1-2.75-6.64V193.75a3.91,3.91,0,0,0-3.9-3.89H365a10.79,10.79,0,0,1-6.65-2.76L348.32,177a10.88,10.88,0,0,1-2.75-6.65V100.32a10.83,10.83,0,0,1,2.75-6.64l10.07-10.07,5.51-5.51,25.63-25.63a10.83,10.83,0,0,1,6.65-2.76H404A10.78,10.78,0,0,0,410.61,47L420.68,36.9a10.78,10.78,0,0,1,6.64-2.76h70.07A10.88,10.88,0,0,0,504,31.39L514.1,21.32a10.88,10.88,0,0,1,6.65-2.75h70.07a3.9,3.9,0,0,1,3.89,3.89v7.79a10.83,10.83,0,0,0,2.76,6.65L607.53,47,613,52.47,623.1,62.53a10.83,10.83,0,0,0,6.65,2.76h7.79A10.77,10.77,0,0,1,644.18,68L654.25,78.1A10.88,10.88,0,0,1,657,84.75v70.07a10.88,10.88,0,0,1-2.75,6.65l-10.07,10.06-5.5,5.51L628.61,187.1a10.88,10.88,0,0,0-2.75,6.65v38.93a3.9,3.9,0,0,1-3.9,3.89H583a3.9,3.9,0,0,0-3.9,3.89v38.93a3.91,3.91,0,0,0,3.9,3.9H622a10.78,10.78,0,0,1,6.65,2.75l10.07,10.06a10.88,10.88,0,0,1,2.75,6.65v23.36a10.83,10.83,0,0,1-2.75,6.64L581.9,389.53a10.83,10.83,0,0,0-2.76,6.65V404a3.91,3.91,0,0,0,3.9,3.9h7.78a3.9,3.9,0,0,1,3.89,3.89v7.79a10.77,10.77,0,0,1-2.75,6.64l-25.64,25.64a10.83,10.83,0,0,1-6.64,2.75H474a10.83,10.83,0,0,0-6.65,2.75l-10.07,10.07a10.83,10.83,0,0,0-2.75,6.65v23.35a10.88,10.88,0,0,0,2.75,6.65l10.07,10.06,5.51,5.51,25.63,25.64a10.78,10.78,0,0,1,2.76,6.64v38.93a10.88,10.88,0,0,1-2.75,6.65l-10.08,10.1-5.5,5.5-10.06,10a10.78,10.78,0,0,0-2.76,6.64v7.79a3.9,3.9,0,0,0,3.9,3.89h7.78a3.9,3.9,0,0,1,3.89,3.89v7.79a3.9,3.9,0,0,1-3.89,3.89H474a10.83,10.83,0,0,0-6.65,2.75l-10.07,10.07-5.5,5.5-10.07,10.07A10.83,10.83,0,0,0,439,692v7.78a3.9,3.9,0,0,0,3.89,3.89h23.36a3.91,3.91,0,0,1,3.89,3.9v38.93a10.83,10.83,0,0,1-2.75,6.64l-10.07,10.07a10.83,10.83,0,0,1-6.64,2.75H411.75a3.9,3.9,0,0,1-3.89-3.89v-7.79a10.78,10.78,0,0,0-2.76-6.64L395,737.61a10.8,10.8,0,0,1-2.75-6.65v-7.78a3.9,3.9,0,0,1,3.89-3.89H404a3.91,3.91,0,0,0,3.9-3.9v-7.78a10.88,10.88,0,0,1,2.75-6.65l10.07-10.06a10.88,10.88,0,0,0,2.75-6.65V645.32a3.9,3.9,0,0,0-3.89-3.89h-7.79a10.88,10.88,0,0,1-6.65-2.75L379.47,613a10.82,10.82,0,0,0-6.65-2.75H365a10.78,10.78,0,0,0-6.65,2.75L348.32,623.1a10.78,10.78,0,0,1-6.64,2.76h-7.79a10.78,10.78,0,0,1-6.64-2.76L317.18,613l-5.5-5.51-10.07-10.06a10.88,10.88,0,0,1-2.75-6.65V567.46a3.9,3.9,0,0,0-3.9-3.89h-7.78a3.9,3.9,0,0,0-3.89,3.89v7.79a3.91,3.91,0,0,1-3.9,3.89H256a3.9,3.9,0,0,1-3.9-3.89V551.89a3.9,3.9,0,0,0-3.89-3.89h-8.07a3.85,3.85,0,0,0-3.85,3.89l.21,23.36a3.86,3.86,0,0,1-3.86,3.89h-7.79a10.83,10.83,0,0,1-6.64-2.75l-10.07-10.07a10.83,10.83,0,0,0-6.64-2.75h-7.79a3.9,3.9,0,0,0-3.89,3.89v23.36a3.9,3.9,0,0,1-3.9,3.89h-7.78a10.82,10.82,0,0,1-6.65-2.75L161.47,581.9a10.83,10.83,0,0,0-6.65-2.76H131.46a10.83,10.83,0,0,1-6.64-2.75l-10.07-10.07a10.83,10.83,0,0,0-6.64-2.75h-7.79a3.9,3.9,0,0,0-3.89,3.89v7.79a3.9,3.9,0,0,1-3.89,3.89H84.75a10.88,10.88,0,0,1-6.65-2.75L68,566.32a10.88,10.88,0,0,0-6.65-2.75H38a10.83,10.83,0,0,1-6.65-2.75L21.32,550.75a10.83,10.83,0,0,1-2.75-6.64v-7.79a10.83,10.83,0,0,1,2.75-6.64l10.07-10.07A10.83,10.83,0,0,1,38,516.86H77a10.83,10.83,0,0,1,6.65,2.75l41.21,41.21a10.83,10.83,0,0,0,6.64,2.75h23.36a3.9,3.9,0,0,0,3.89-3.89v-7.79a3.9,3.9,0,0,0-3.89-3.89H131.46a10.83,10.83,0,0,1-6.64-2.75L83.61,504A10.78,10.78,0,0,0,77,501.29H69.18a3.91,3.91,0,0,1-3.89-3.9v-7.78a3.91,3.91,0,0,1,3.89-3.9h38.93a10.78,10.78,0,0,1,6.64,2.76l25.64,25.63a10.79,10.79,0,0,0,6.65,2.76h7.78a3.9,3.9,0,0,0,3.89-3.9v-7.78a3.9,3.9,0,0,0-3.89-3.89H147a10.79,10.79,0,0,1-6.65-2.76L114.75,472.9a10.78,10.78,0,0,0-6.64-2.76h-7.79a3.9,3.9,0,0,1-3.89-3.89v-7.79a3.9,3.9,0,0,1,3.89-3.89h23.36c2.14,0,2.65-1.24,1.14-2.75l-10.07-10.07a10.83,10.83,0,0,1-2.75-6.64v-7.79a3.9,3.9,0,0,1,3.89-3.89h7.79a10.83,10.83,0,0,0,6.64-2.75l44-44Z"/>
							<path d="M131.46,594.71a10.77,10.77,0,0,1-6.64-2.75L114.75,581.9a3.89,3.89,0,0,0-5.5,0L99.18,592a10.77,10.77,0,0,1-6.64,2.75H84.75A10.82,10.82,0,0,1,78.1,592L68,581.9a10.83,10.83,0,0,0-6.65-2.76H6.89A3.9,3.9,0,0,0,3,583v23.35a3.89,3.89,0,0,0,3.89,3.89H30.25a3.9,3.9,0,0,0,3.89-3.89v-7.78a3.91,3.91,0,0,1,3.9-3.9h7.78a10.83,10.83,0,0,1,6.65,2.76l25.63,25.6a10.83,10.83,0,0,0,6.65,2.76l23.36,0a10.72,10.72,0,0,0,6.64-2.75l25.64-25.63c1.51-1.52,1-2.76-1.14-2.76Z"/>
							<rect x="91.5" y="708" width="85.5" height="30"/>
						</g>
						<g className="klasse1">
							<path d="M379.66,446.2a23.33,23.33,0,0,1-46.65,0c0-12.88,10.58-25.22,23.33-23.33,34.14,5.06,46.75,15.5,42.56,20.18C396.08,446.2,379.66,444,379.66,446.2Z"/>
							<path d="M423.43,314.43c0-7.51-15.57-7.79-23.36,0,0,0-7.78,0-15.57-7.79-5.51-5.5-15.57,7.79-15.57,15.57s7.78,15.58,15.57,15.58c2.34,0,7.83,10.34,10,9.69,2.86,2.31,8.12,5.88,13.4,5.88,6.86,0,7.67-18.12,2.44-22.44a23.17,23.17,0,0,0,.74-5.44C417.1,322.53,423.43,318.48,423.43,314.43Z"/>
							<path d="M516.86,384.5c-6.95-6.94-14.77-19.92-23.36-23.36,3.13-4,23.36-10.12,23.36-15.57,0-12.88-27-12.43-34.68-22.76-12-16.17-12,15-23.28,22.53A23.3,23.3,0,0,0,429,380.56c1.07,7-.76,6.95-5.53,11.73-3.12,3.11,6.18,5.92,9.2.21,4.88-9.23,15.94-2.81,8.68,7.58H439c-10.3,0-19.54,1.88-22.85,9.21-1.1-12.27-11.67-24.78-23.86-24.78-12.89,0-22.21,3.11-22.21,16s17.7,25,21.79,25c10.33,0,20.14,2.46,23.2-6.85,1.61,9.68,12.17,7.57,23.55,10.88,35.48,10.3,12.83-5.61,22.88-13.66,13.27-10.63,3.43-14.11-8.13-15.25,1.33-4.34,4-11.18,9-16.12a13,13,0,0,0,3.45-9.48,29.72,29.72,0,0,0,4.33-13.88c1.27.83,14.15-.57,15.57,0,0,15.57-17.2,15.61-17.2,21.06a23.32,23.32,0,0,0,19.36,23,23.32,23.32,0,0,0,15.21,41c12.89,0,29.35-9.85,29.35-22.73C532.43,411.9,524.64,392.29,516.86,384.5Z"/>
							<path d="M317.18,311.68l16.15-16.15a23.25,23.25,0,0,1,9.54,31.35,23.23,23.23,0,0,1,2.24,15.47c-2.72.65-4.79,4.11-4.79,8.28,0,4.65,2.56,8.41,5.72,8.41s5.71-3.76,5.71-8.41a12.21,12.21,0,0,0-.28-2.61c12.3.38,16.16,10.65,16.16,23.29,0,12.88-4,23.32-16.87,23.32a23.21,23.21,0,0,1-16.72-7.1,23,23,0,0,1,.83,6.07,23.31,23.31,0,0,1-13.93,21.34,23.32,23.32,0,0,1-23,19.63c-3.88,0-8.86,2.52-13.31,4.77a23.32,23.32,0,0,1-6.95,45.59c-6.62,0-17.74,24.14-17.74.78-7.79,0-15.57-15.57-24.12,6.8-8.92,23.34-21.46-.76-28-19.56-11.54-.23-23.46-5.6-25.06-16.75-5.93-1.92-10.49-6.69-13.28-12.16-6-.74-10.58-4.76-13.67-10,8,2.35,18.46-2.85,18.46-2.85a154.28,154.28,0,0,0-31.06-23.44l15.48-15.48,15.58-15.58c7.23-7.23,15.05-18.12,22.18-30.14.33,0,.66,0,1,0a23.27,23.27,0,0,1,8.33,1.56c.85-.09,6.54,13.05,7.41,13.05,1.72,0,1.66-24.89,1.41-31.68a20.12,20.12,0,0,0-3.72-10.95c6.11-14,10.1-26.93,10.1-35.22v-46.5c8.82-4.68,18.95-8,23.36-8,8.6,0,15.57,8.71,15.57,19.46s-7,19.46-15.57,19.46h-.8a23.44,23.44,0,0,1,4.79,6c3.79,9.63,19.36,1.84,19.36-6,3.47-8.53-1-15.69,0-15.57,0,0,5.79-5,5.79-11.89a23.33,23.33,0,1,1,46.65,0,23,23,0,0,1-1.7,7.87l-1.27,1.27a10.83,10.83,0,0,1-6.64,2.75h-7.79a3.9,3.9,0,0,0-3.89,3.9v3.89c-7.79,0-31.15,64.67,0,46.19v8.31h15.57Zm-17.53,27.61c-4.68,0-8.47,2.54-8.47,5.66s3.79,5.66,8.47,5.66,8.46-2.53,8.46-5.66S304.32,339.29,299.65,339.29ZM272.4,281.85c-2.85,0-5.16,3-5.16,6.75s2.31,6.74,5.16,6.74,5.16-3,5.16-6.74S275.25,281.85,272.4,281.85Zm32.51,85.21c-4.49,0-8.12,3-8.12,6.71s3.63,6.72,8.12,6.72,8.12-3,8.12-6.72S309.4,367.06,304.91,367.06ZM193.19,399c4-5.67,5.37-11.63,3-13.31s-7.55,1.55-11.58,7.21-5.38,11.63-3,13.32S189.16,404.63,193.19,399Zm80.67,39.64c.64-3.9,3.43-11,9.43-23,1.1-2.2-.71-13.34,0-15.57,0,0-6.58,6.56-25.72,7.63,0,.8-.05,1.58-.05,2.34a23.29,23.29,0,0,1-15.77,22c-4.58-.36-7.37-2.75-3.33-12.29-10.66,0-19.3,7.45-19.3,16.63s8.64,16.64,19.3,16.64a22.18,22.18,0,0,0,5.64-.73,32.29,32.29,0,0,1,10.79,4.45A23.34,23.34,0,0,1,273.86,438.6Zm19.59-73.2a22.41,22.41,0,0,1-.13-11.6,23.12,23.12,0,0,1-20.19,5.71,8.27,8.27,0,1,0-13.9-8.53l-.2-.25a23.11,23.11,0,0,1-12-5.81,23.3,23.3,0,0,1-23.47,8.64,23.26,23.26,0,0,1,8.16,17.7c0,.4,0,.8,0,1.19-.64,0-1.28-.05-1.93-.05-10.25,0-18.57,4.31-18.57,9.62s8.32,9.62,18.57,9.62c5.36,0,19-5.26,22.39-7.14,5.05,2.15,5.95,7.51,5.88,13.55a23.66,23.66,0,0,0,15.4-4c-2.08-1.36-3.61-3-3.61-5.32a24.17,24.17,0,0,1,.28-3.43c.28,0,.55,0,.83,0a22.56,22.56,0,0,0,22.39-19.92Z"/>
							<path d="M158.71,501.29c7.79-7.79-7.78-15.58-7.78-15.58s0-15.46-7.79-23.35c0,0-7.78,7.78-23.35-7.79H96.43v15.57H112l31.14,31.15Z"/>
							<path d="M236.57,158.71V178A23.29,23.29,0,0,0,261,174.29h-8.85V158.71Z"/>
							<path d="M625.86,189.86l5.23-5.23c-5.13-7.8-15.21-11.46-28.62-2.5-10.71,7.16-23.33,10.45-23.33,23.33,0,7.75,15.57,23.33,23.33,23.33,8.27,0,17.06-4.61,23.39-11.14Z"/>
							<path d="M657,96.43V80.86L641.43,65.29h-7.79s0,7.78-7.78,7.78-23.36-7.78-31.15-7.78-7.78,23.35-7.78,23.35-23.54-23.17-23.86-22.85a23.26,23.26,0,0,0-39.22,8c-8.2,7.73-29.39,21.4-44.41,15.48-6.39-6.37-12.38-9.52-12.12-3.43.58,13.6-12.44,21.66-19.8,28.4a6.93,6.93,0,0,0-1.88,8.15c-2,.06-4.23.15-6.71.29a17,17,0,0,0-5.58,1.35c-2.4-3.38-5-7.44-1.25-8.4,5.06-1.3,4.94,4.12,10.89-3.09s20.24-20.45,16.89-24.37c-2.43-2.86-11.13-3.84-18.23-2-2.72-8.29-11.73-10.86-22.46-10.86-12.88,0-33.38,3.45-31.41,16.18.86,5.56,12.45,11.72,21.9,17.32-3.41.13-8.25,1.2-15,3.53-1.92.66-5.65,2.17-5.65,2.17-12.3,5.25-27.87,5.25-43.44-2.54v7.79c15.57,7.78,21.76,11.73,26.45,21.44S383.69,159,394.66,159c12.88,0,11-11.86,15.12-24.08,1.7-5.08,4.54-10.82,6-15.63,3.38,3.9,5.16,8.88,5.67,14.95-4.17,5.89-6.82,13.09-6.82,19.29,0,12.89,14.65,13.8,23.32,23.33,20.33,22.32,35.17-18.1,31.46-22-7.37-7.76-8.28-14.18-7.85-19.21a26.48,26.48,0,0,0,9.25,2,23.18,23.18,0,0,0,12.87-3.88c2,2.65,2,4.46,2,9.4,0,7.79,7.79,0,7.79-7.78s8.62-15.61.42-23.38c9.22-.24,18.4-8.53,24.29-15.16a23.37,23.37,0,0,0,15.14,16.25,12.47,12.47,0,0,1,2.06,9.88,23.3,23.3,0,0,0-3.94,41.36l-.14.05c7.78,7.78,8.88,9.93,1.1,9.93s-15.57-7.79-7.79,7.78q5.21,10.4,5.76,16.16a23,23,0,0,0-7.5-1.25A23.29,23.29,0,0,0,503,208.22a24,24,0,0,0-2.71-1.85c.36-.31.71-.63,1-.94,7.78-7.79,7.78-15.57,0-15.57s-7.79,15.57-23.36,0c-13.15-13.15-15.19,1.47-10.82,20.4,5.92,6.17,10.82,12.35,10.82,18.53,0,.12,0,.25,0,.38a59.23,59.23,0,0,0-7.44,10.08c-.33.25-3.34,9.87-.32,12.89l7.79,7.79c0,6.94-12.39,7.69-26.11,7.77a23.67,23.67,0,0,0-2,6.15,20.92,20.92,0,0,0-3,9.44s0,15.57-7.79,15.57-7.79,15.57,7.79,7.78a24.75,24.75,0,0,0,10.78-11.21,23.21,23.21,0,0,0,25.31,3.4c13.76-.24,26.19-2.46,26.19-23.33,0-22.34-7.13-16.2-21.37-15.62-.52-.43-1.07-.84-1.63-1.23.19-2.78.49-5.9.95-8.89.48,0,1,0,1.46,0a23.28,23.28,0,0,0,19.92-11.24,23.28,23.28,0,0,0,36.36-10.2,11.77,11.77,0,0,0,3.24.43c7.57,0,9.61,3.67,9.72,7.45a23.32,23.32,0,0,0-22.9,23.31c0,.16,0,.32,0,.48-5.63.33-10.2,1.72-10.2,7.68,0,7.79,15.57,15.58,23.36,15.58s15.57,7.78,7.79,15.57a30.07,30.07,0,0,0-2.12,2.36,23.29,23.29,0,0,0-4.25,43.65c4.94,11.57,21.89,15.8,33.94,22.08A23.4,23.4,0,0,0,594,377.45L641.43,330a151.83,151.83,0,0,1-24.24,7.13,23.25,23.25,0,0,0-25.17-.49,18.37,18.37,0,0,1-9.8-8.06A23.34,23.34,0,0,0,566,301.46c.94-6.63,1.51-14.45.29-20.09a23.43,23.43,0,0,0,12.81-11.69V236.57h15.57s0-7.78-23.35-7.78c-15.57,0-15.57-7.79-15.57-15.58,0-14.48-6.74-2-13.95-6.49a24.31,24.31,0,0,0-3.28-3.67c.77-3,3.26-5.41,9.44-5.41,7.79,0-4.43-15.57-4.43-23.35a26.43,26.43,0,0,1,.85-6.35,23.29,23.29,0,0,0,17-38.74c4.46-5.22,9.94-12.58,9.94-17.2,0-4.38-4.93-8.76-9.24-11.75.46-1.06,3.65-6.49,4.57-8.32,11.57,6.43,22.07,20.07,28,20.07h1c1.87,1.59,3.37,6,3.37,6,1.13,5.44,9.72,10.25-16.77,20.8-12,4.77-3.78,32.4,23.33,23.33,2.65-.89,5.47-.52,8-1.42a29.79,29.79,0,0,0,4.51,5.74c7.79,7.79,15.57,0,15.57,0s-7.78-7.79-7.78-15.57a3.17,3.17,0,0,1,.08-.69c.22-.39.42-.8.62-1.2,4.59-5.89,30.44-5.9,30.44-5.9V127.57s-21.1,0-36.56-6.69a23.53,23.53,0,0,0-6-3.62A23.25,23.25,0,0,0,625.88,112C641.44,112,657,96.43,657,96.43Z"/>
							<path d="M594.71,423.43V407.86H579.14v-7.64c-1.27-.1-2.55-.15-3.86-.15-19.33,0-27.28,2.69-27.28,15.57S559.81,439,579.14,439Z"/>
							<path d="M454.57,501.29V470.14l15.57-15.57h15.57s-7.78-7.78-23.35-7.78h-18.1a23,23,0,0,0-9.11-3.54,23.31,23.31,0,1,0-12.34,44.65,23.37,23.37,0,0,0,4.58,1.3c-4.5,4.25-3.65,11.37-7.33,16.95-12.2,18.49-4.47,34.23,23.33,23.32,9.85-3.86,19.24-8.43,22.29-17.08Z"/>
							<path d="M370,540.2c0,3.08-3.92,5.58-8.76,5.58s-8.77-2.5-8.77-5.58,3.93-5.58,8.77-5.58S370,537.12,370,540.2Zm131.28,54.51v-11.8c-7.15-3.66-19.17-4.14-23.67-11.71-23.05-38.77-17.71,7-17.42,19.85A187.36,187.36,0,0,0,462,615.66a23.3,23.3,0,0,0-23.57,9.07,35.31,35.31,0,0,1-10-3.07c0-.28.05-.55.05-.84a23.26,23.26,0,0,0-29.42-22.49L395.93,593a23.42,23.42,0,0,0,6.6-11.29,23.31,23.31,0,0,0-8.5-45,23.07,23.07,0,0,0-11.58,3.1,17,17,0,0,0,1.82-7.83,21.06,21.06,0,0,1,1.71-8c5.44-8.16,21.62-4.89,21.62-15.32a23.32,23.32,0,0,0-23.33-23.32c-12.88,0-17.72,5.2-17.72,18.08,8.94-.74,10.58,5.45,11.11,12.26-5.53,5.05-11,9-16.52,9-6.53,0-13.05,0-15-4.62a23.31,23.31,0,1,0-32.63-32.52c-13.85,2.78-22.58,8.34-22.46,13.79.17,7.37,12.49.73,12.51,7.78,0,2.53-1.78,10-2.26,11.67-2.11,6.13-5.59,11.81-10.08,11.69-6.5-.18-13,6-19.91,2.64a24,24,0,0,0,.23-3.08c0-12.88,6.29-40.2-23.36-15.32-9.87,8.28-23.3,2.44-23.3,15.32a23.29,23.29,0,0,0,11.67,20.18V548h15.57v7a23.24,23.24,0,0,0,11.61-5.6,39.32,39.32,0,0,0,14.5-.1c2.78,9,10.87,13.61,20.61,14.3v7.79c15-.29,22.62-.05,23.3-20.27a23.27,23.27,0,0,0-9.9-28.86c-1.24-3.89-1.54-6.9-.32-9.65a23.17,23.17,0,0,0,25.8,11.36c4.23,7.66,7.44,20.09,7.79,30a23.39,23.39,0,0,0-1.76,4.3,23.31,23.31,0,1,0,22.59,40.31,95.39,95.39,0,0,1,1.82,11.71h8.53l31.15,31.14h8.22a23.87,23.87,0,0,0,4.34-2.95,59.28,59.28,0,0,1,13.78-3.38,23.75,23.75,0,0,0-.27,3.4A23.17,23.17,0,0,0,436.46,649c-8.4,8.09-13,18.13-13,23.54.29.29,0,15.57,0,15.57l-15.57,15.57v15.58H392.29v15.57l15.57,15.57v9.29a23.27,23.27,0,0,0,17.49-10.07,31.08,31.08,0,0,0,44.79-2V703.71H439V688.14l6.32-6.32A23.6,23.6,0,0,0,439,676.4c0-8.95.36-15.11,2.87-20.39a23.23,23.23,0,0,0,26,3.22l2.23-2.23h1.28a23.26,23.26,0,0,0,9-15.57H470.14V625.86Z"/>
							<path d="M104.92,586.22,99.18,592a10.77,10.77,0,0,1-6.64,2.75H84.75A10.82,10.82,0,0,1,78.1,592l-8.16-8.16a25.92,25.92,0,0,0-9.82,20.33c0,.34,0,.68.05,1L78.1,623.07a10.83,10.83,0,0,0,6.65,2.76h15.62a25.94,25.94,0,0,0,4.55-39.62Z"/>
							<path d="M87.81,523.81a30.53,30.53,0,0,0-16.52,45.76l9,9c.3.19.59.38.9.56H96.43V563.57H112l6.55,6.55a34.33,34.33,0,0,0,6.74-8.83Z"/>
							<path d="M188.79,525a23.29,23.29,0,0,0-12.95,3.92c-.8-3.45-3.74-7.46-8.14-10.59a23.31,23.31,0,0,0-9-4v2.54h-8.35c-2.06,3.81,1.27,10.35,7.76,15a25.94,25.94,0,0,0,3,1.82A23.39,23.39,0,0,0,144.49,548h14.22v15.57H144.07a23.32,23.32,0,0,0,40.19,7.63,23.35,23.35,0,0,0,4.53.45c.36,0,.71,0,1.07-.06v-8h15.57l.52.52A23.3,23.3,0,0,0,188.79,525Z"/>
							<rect x="6" y="708" width="85.5" height="30"/>
						</g>
						<g className="klasse3">
							<path d="M345.57,283.29c15.57,0,54.5,0,62.29-31.15H376.71Z"/>
							<path d="M563.57,18.57c0,15.57-38.93,23.36-62.28,46.72s-31.21-6.65-54.5-7.79c-23.46-1.15-32-1-77.86,15.57l23.36-23.36h15.57l15.57-15.57h77.86l15.57-15.57Z"/>
							<path d="M610.29,49.71c-31.15,7.79-38.93,0-31.15-31.14h15.57V34.14Z"/>
							<circle cx="261.16" cy="203.55" r="6.89"/>
							<path d="M392.29,189.86c7.78-31.15-7.53-15.54-15.58-7.79s-15.57-7.78-7.78-15.57,8.05-15.43,0-15.57-15.57,7.78-23.36,7.78v15.58l15.57,15.57Z"/>
							<ellipse cx="495.97" cy="169.11" rx="15.77" ry="8.16"/>
							<path d="M641.43,314.43c-46.72,7.78-54.5,0-46.72-31.14h31.15l15.57,15.57Z"/>
							<circle cx="541.25" cy="369.87" r="5.55"/>
							<path d="M407.86,252.14c15.57,15.57,31,7.76,38.93,0s7.78-23.35,7.78-38.93S439,197.64,431.21,197.64s-15.57,0-15.57,7.79c0,15.57-15.57,7.78-23.35-7.79v38.93Z"/>
							<ellipse cx="253.86" cy="367.39" rx="4.99" ry="9.48" transform="translate(-185.43 287.11) rotate(-45)"/>
							<path d="M112,439c31.1,7.9,62.29,7.79,15.57-15.57H112Z"/>
							<path d="M119.79,540.21c7.78-7.78,0-31.14,0-46.71L112,485.71H65.29v15.58H80.86Z"/>
							<path d="M34.14,563.57c0-15.57,0-23.36,23.36-46.71H34.14L18.57,532.43V548Z"/>
							<path d="M34.14,594.71c0-7.78,7.79-7.78,15.57-15.57H3v31.15H34.14Z"/>
							<path d="M127.57,610.29c.22,0-7.78-7.79,0-15.58h15.57Z"/>
							<circle cx="470.57" cy="308.31" r="4.87"/>
							<path d="M244.36,104.21l-5,5a10.83,10.83,0,0,0-2.75,6.64v23.36a3.9,3.9,0,0,0,3.89,3.89h7.79a10.88,10.88,0,0,0,6.65-2.75l25.63-25.64a3.85,3.85,0,0,0,1.1-2.34C252.16,119.77,252,119.5,244.36,104.21Z"/>
							<path d="M174.29,470.14c-7.82-7.8-23.36-15.57-31.15-7.78,7.77,7.89,7.79,23.35,7.79,23.35C166.5,485.71,182.1,477.94,174.29,470.14Z"/>
							<rect x="177" y="708" width="85.5" height="30"/>
						</g>
						<g className="klasse4">
							<path d="M270.47,78.1c-1.52,1.52-1,2.76,1.14,2.76h7.78A10.83,10.83,0,0,0,286,78.1L296.1,68c1.52-1.52,1-2.75-1.14-2.75h-7.78A10.82,10.82,0,0,0,280.53,68Z"/>
							<path d="M314.43,45.82a3.9,3.9,0,0,0,3.89,3.89h23.36A10.77,10.77,0,0,0,348.32,47L374,21.32c1.52-1.51,1-2.75-1.14-2.75H365a10.83,10.83,0,0,0-6.65,2.75L348.32,31.39a10.83,10.83,0,0,1-6.64,2.75H318.32a3.9,3.9,0,0,0-3.89,3.9Z"/>
							<path d="M392.29,30.25c0,2.14,1.23,2.65,2.75,1.14L405.1,21.32a10.88,10.88,0,0,1,6.65-2.75h23.36A3.9,3.9,0,0,0,439,14.68V6.89A3.9,3.9,0,0,0,435.11,3H411.75a10.88,10.88,0,0,0-6.65,2.75L395,15.82a10.77,10.77,0,0,0-2.75,6.64Z"/>
							<path d="M470.14,14.68c0,2.14,1.24,2.65,2.76,1.14L483,5.75C484.48,4.24,484,3,481.82,3H474a3.9,3.9,0,0,0-3.9,3.89Z"/>
							<path d="M281.63,112.41a3.84,3.84,0,0,0-1.1-3.16L270.47,99.18a10.88,10.88,0,0,0-6.65-2.75H256a10.83,10.83,0,0,0-6.65,2.75l-5,5C252,119.5,252.16,119.77,281.63,112.41Z"/>
							<rect x="262.5" y="708" width="85.5" height="30"/>
						</g>
					</g>
					<g className="provinciegrens">
						<path d="M454.57,485.71H426.43a8.31,8.31,0,0,1-5.12-2.12L410,472.26a8.39,8.39,0,0,0-5.12-2.12H364.14a8.39,8.39,0,0,0-5.12,2.12l-11.33,11.33a8.31,8.31,0,0,1-5.12,2.12H317.43a8.31,8.31,0,0,1-5.12-2.12L301,472.26a8.39,8.39,0,0,0-5.12-2.12H255.14a8.39,8.39,0,0,0-5.12,2.12l-26.9,26.9a8.34,8.34,0,0,1-5.12,2.13H177.29a8.36,8.36,0,0,0-5.13,2.12l-11.32,11.33a8.32,8.32,0,0,0-2.13,5.12v59.28"/>
						<path d="M439,485.71v12.58a8.33,8.33,0,0,0,2.12,5.12l26.9,26.9c1.17,1.16.77,2.12-.88,2.12H426.43c-1.65,0-2.05,1-.88,2.12l11.33,11.33A8.33,8.33,0,0,1,439,551v40.71a3,3,0,0,1-3,3h-9.57a8.32,8.32,0,0,0-5.12,2.13l-29,29"/>
						<path d="M283.29,470.14V457.57a3,3,0,0,1,3-3h9.57a8.33,8.33,0,0,0,5.12-2.12l26.9-26.9a8.33,8.33,0,0,1,5.12-2.12h56.29a3,3,0,0,0,3-3V395.29a3,3,0,0,0-3-3h-9.58a8.34,8.34,0,0,1-5.12-2.13l-11.33-11.32a8.42,8.42,0,0,1-2.12-5.13V345.57"/>
						<path d="M388.39,189.86h32a8.33,8.33,0,0,1,5.12,2.12l26.9,26.9a8.33,8.33,0,0,1,2.12,5.12v9.57a8.31,8.31,0,0,1-2.12,5.12L441.12,250a8.33,8.33,0,0,0-2.12,5.12v25.15a8.33,8.33,0,0,1-2.12,5.12l-11.33,11.33a8.39,8.39,0,0,1-5.12,2.12h-9.57a8.31,8.31,0,0,0-5.12,2.12l-26.9,26.9a8.34,8.34,0,0,0-2.13,5.12v9.57a3,3,0,0,1-3,3h-9.57a8.33,8.33,0,0,1-5.12-2.12l-11.33-11.33a8.31,8.31,0,0,0-5.12-2.12H317.43a8.31,8.31,0,0,1-5.12-2.12L301,316.55a8.33,8.33,0,0,1-2.12-5.12v-4.79"/>
						<path d="M205.43,330H218a3,3,0,0,1,3,3v25.14a3,3,0,0,0,3,3h25.14a8.31,8.31,0,0,0,5.12-2.12l26.9-26.9a8.36,8.36,0,0,1,5.13-2.12h9.57a3,3,0,0,1,3,3v25.14a3,3,0,0,0,3,3H327a3,3,0,0,0,3-3v-9.57a8.33,8.33,0,0,1,2.12-5.12L345.57,330"/>
						<path d="M291.07,454.57h-4.78a8.36,8.36,0,0,1-5.13-2.12l-26.9-26.9a8.39,8.39,0,0,1-2.12-5.12V395.29a8.42,8.42,0,0,1,2.12-5.13l11.33-11.32a3,3,0,0,0,0-4.25l-13.45-13.45"/>
						<path d="M439,283.29h28.14a3,3,0,0,1,3,3V327a8.39,8.39,0,0,0,2.12,5.12l11.33,11.33a8.33,8.33,0,0,0,5.12,2.12h25.15a8.39,8.39,0,0,1,5.12,2.12L530.31,359a8.31,8.31,0,0,0,5.12,2.12H545a8.39,8.39,0,0,1,5.12,2.12l11.33,11.33a8.33,8.33,0,0,0,5.12,2.12h28.14"/>
						<path d="M419.54,189.86h47.6a8.37,8.37,0,0,0,5.12-2.12l26.9-26.9a8.37,8.37,0,0,1,5.13-2.13h9.57a3,3,0,0,0,3-3V130.57a8.39,8.39,0,0,0-2.12-5.12l-11.33-11.33a8.33,8.33,0,0,0-5.12-2.12h-9.58a3,3,0,0,1-3-3V68.29a8.37,8.37,0,0,1,2.13-5.13l11.32-11.32c1.17-1.17.78-2.13-.87-2.13h-9.58a8.33,8.33,0,0,1-5.12-2.12L470.14,34.14"/>
						<path d="M501.29,112l29-29a3,3,0,0,1,4.24,0l26.9,26.9a8.33,8.33,0,0,0,5.12,2.12h9.57a8.31,8.31,0,0,1,5.12,2.12l42.48,42.47a8.39,8.39,0,0,1,2.12,5.12v28.15"/>
						<path d="M470.14,189.86l13.45,13.45a8.31,8.31,0,0,1,2.12,5.12v25.14a3,3,0,0,0,3,3h9.58a8.39,8.39,0,0,1,5.12,2.12L514.74,250a8.31,8.31,0,0,0,5.12,2.12h9.57a8.33,8.33,0,0,0,5.12-2.12l11.33-11.33a8.39,8.39,0,0,1,5.12-2.12h32"/>
					</g>
					<g className="contour">
						<path d="M131.46,594.71a10.77,10.77,0,0,1-6.64-2.75L114.75,581.9a3.89,3.89,0,0,0-5.5,0L99.18,592a10.77,10.77,0,0,1-6.64,2.75H84.75A10.82,10.82,0,0,1,78.1,592L68,581.9a10.83,10.83,0,0,0-6.65-2.76H6.89A3.9,3.9,0,0,0,3,583v23.35a3.89,3.89,0,0,0,3.89,3.89H30.25a3.9,3.9,0,0,0,3.89-3.89v-7.78a3.91,3.91,0,0,1,3.9-3.9h7.78a10.83,10.83,0,0,1,6.65,2.76l25.63,25.6a10.83,10.83,0,0,0,6.65,2.76l23.36,0a10.72,10.72,0,0,0,6.64-2.75l25.64-25.63c1.51-1.52,1-2.76-1.14-2.76Z"/>
						<path d="M236.57,139.25a3.9,3.9,0,0,0,3.89,3.89h7.79a10.88,10.88,0,0,0,6.65-2.75l25.63-25.64a3.89,3.89,0,0,0,0-5.5L270.47,99.18a10.88,10.88,0,0,0-6.65-2.75H256a10.83,10.83,0,0,0-6.65,2.75l-10.07,10.07a10.83,10.83,0,0,0-2.75,6.64Z"/>
						<path d="M270.47,78.1c-1.52,1.52-1,2.76,1.14,2.76h7.78A10.83,10.83,0,0,0,286,78.1L296.1,68c1.52-1.52,1-2.75-1.14-2.75h-7.78A10.82,10.82,0,0,0,280.53,68Z"/>
						<path d="M314.43,45.82a3.9,3.9,0,0,0,3.89,3.89h23.36A10.77,10.77,0,0,0,348.32,47L374,21.32c1.52-1.51,1-2.75-1.14-2.75H365a10.83,10.83,0,0,0-6.65,2.75L348.32,31.39a10.83,10.83,0,0,1-6.64,2.75H318.32a3.9,3.9,0,0,0-3.89,3.9Z"/>
						<path d="M392.29,30.25c0,2.14,1.23,2.65,2.75,1.14L405.1,21.32a10.88,10.88,0,0,1,6.65-2.75h23.36A3.9,3.9,0,0,0,439,14.68V6.89A3.9,3.9,0,0,0,435.11,3H411.75a10.88,10.88,0,0,0-6.65,2.75L395,15.82a10.77,10.77,0,0,0-2.75,6.64Z"/>
						<path d="M470.14,14.68c0,2.14,1.24,2.65,2.76,1.14L483,5.75C484.48,4.24,484,3,481.82,3H474a3.9,3.9,0,0,0-3.9,3.89Z"/>
						<path d="M158.71,392.29l15.58-15.58h0c20.9-20.9,46.71-72.31,46.71-93.42v-74a10.83,10.83,0,0,1,2.75-6.64l10.07-10.07a10.83,10.83,0,0,0,2.75-6.65V162.61a3.91,3.91,0,0,1,3.89-3.9h7.79a3.91,3.91,0,0,1,3.89,3.9v7.78a3.91,3.91,0,0,0,3.9,3.9h7.78a10.78,10.78,0,0,0,6.64-2.76l10.13-10.15a10.7,10.7,0,0,1,6.64-2.74l7.73.05a3.94,3.94,0,0,1,3.9,3.92v38.93a3.9,3.9,0,0,0,3.89,3.89h23.36a3.9,3.9,0,0,1,3.89,3.89v23.36a10.83,10.83,0,0,1-2.75,6.64l-10.07,10.07a10.83,10.83,0,0,1-6.64,2.75h-7.79a3.9,3.9,0,0,0-3.89,3.9v54.5a3.9,3.9,0,0,0,3.89,3.89h7.79a10.83,10.83,0,0,0,6.64-2.75L374,254.9a10.83,10.83,0,0,1,6.65-2.76H404c2.15,0,2.66-1.24,1.14-2.75L395,239.32a10.77,10.77,0,0,1-2.75-6.64V193.75a3.91,3.91,0,0,0-3.9-3.89H365a10.79,10.79,0,0,1-6.65-2.76L348.32,177a10.88,10.88,0,0,1-2.75-6.65V100.32a10.83,10.83,0,0,1,2.75-6.64l10.07-10.07,5.51-5.51,25.63-25.63a10.83,10.83,0,0,1,6.65-2.76H404A10.78,10.78,0,0,0,410.61,47L420.68,36.9a10.78,10.78,0,0,1,6.64-2.76h70.07A10.88,10.88,0,0,0,504,31.39L514.1,21.32a10.88,10.88,0,0,1,6.65-2.75h70.07a3.9,3.9,0,0,1,3.89,3.89v7.79a10.83,10.83,0,0,0,2.76,6.65L607.53,47,613,52.47,623.1,62.53a10.83,10.83,0,0,0,6.65,2.76h7.79A10.77,10.77,0,0,1,644.18,68L654.25,78.1A10.88,10.88,0,0,1,657,84.75v70.07a10.88,10.88,0,0,1-2.75,6.65l-10.07,10.06-5.5,5.51L628.61,187.1a10.88,10.88,0,0,0-2.75,6.65v38.93a3.9,3.9,0,0,1-3.9,3.89H583a3.9,3.9,0,0,0-3.9,3.89v38.93a3.91,3.91,0,0,0,3.9,3.9H622a10.78,10.78,0,0,1,6.65,2.75l10.07,10.06a10.88,10.88,0,0,1,2.75,6.65v23.36a10.83,10.83,0,0,1-2.75,6.64L581.9,389.53a10.83,10.83,0,0,0-2.76,6.65V404a3.91,3.91,0,0,0,3.9,3.9h7.78a3.9,3.9,0,0,1,3.89,3.89v7.79a10.77,10.77,0,0,1-2.75,6.64l-25.64,25.64a10.83,10.83,0,0,1-6.64,2.75H474a10.83,10.83,0,0,0-6.65,2.75l-10.07,10.07a10.83,10.83,0,0,0-2.75,6.65v23.35a10.88,10.88,0,0,0,2.75,6.65l10.07,10.06,5.51,5.51,25.63,25.64a10.78,10.78,0,0,1,2.76,6.64v38.93a10.88,10.88,0,0,1-2.75,6.65l-10.08,10.1-5.5,5.5-10.06,10a10.78,10.78,0,0,0-2.76,6.64v7.79a3.9,3.9,0,0,0,3.9,3.89h7.78a3.9,3.9,0,0,1,3.89,3.89v7.79a3.9,3.9,0,0,1-3.89,3.89H474a10.83,10.83,0,0,0-6.65,2.75l-10.07,10.07-5.5,5.5-10.07,10.07A10.83,10.83,0,0,0,439,692v7.78a3.9,3.9,0,0,0,3.89,3.89h23.36a3.91,3.91,0,0,1,3.89,3.9v38.93a10.83,10.83,0,0,1-2.75,6.64l-10.07,10.07a10.83,10.83,0,0,1-6.64,2.75H411.75a3.9,3.9,0,0,1-3.89-3.89v-7.79a10.78,10.78,0,0,0-2.76-6.64L395,737.61a10.8,10.8,0,0,1-2.75-6.65v-7.78a3.9,3.9,0,0,1,3.89-3.89H404a3.91,3.91,0,0,0,3.9-3.9v-7.78a10.88,10.88,0,0,1,2.75-6.65l10.07-10.06a10.88,10.88,0,0,0,2.75-6.65V645.32a3.9,3.9,0,0,0-3.89-3.89h-7.79a10.88,10.88,0,0,1-6.65-2.75L379.47,613a10.82,10.82,0,0,0-6.65-2.75H365a10.78,10.78,0,0,0-6.65,2.75L348.32,623.1a10.78,10.78,0,0,1-6.64,2.76h-7.79a10.78,10.78,0,0,1-6.64-2.76L317.18,613l-5.5-5.51-10.07-10.06a10.88,10.88,0,0,1-2.75-6.65V567.46a3.9,3.9,0,0,0-3.9-3.89h-7.78a3.9,3.9,0,0,0-3.89,3.89v7.79a3.91,3.91,0,0,1-3.9,3.89H256a3.9,3.9,0,0,1-3.9-3.89V551.89a3.9,3.9,0,0,0-3.89-3.89h-8.07a3.85,3.85,0,0,0-3.85,3.89l.21,23.36a3.86,3.86,0,0,1-3.86,3.89h-7.79a10.83,10.83,0,0,1-6.64-2.75l-10.07-10.07a10.83,10.83,0,0,0-6.64-2.75h-7.79a3.9,3.9,0,0,0-3.89,3.89v23.36a3.9,3.9,0,0,1-3.9,3.89h-7.78a10.82,10.82,0,0,1-6.65-2.75L161.47,581.9a10.83,10.83,0,0,0-6.65-2.76H131.46a10.83,10.83,0,0,1-6.64-2.75l-10.07-10.07a10.83,10.83,0,0,0-6.64-2.75h-7.79a3.9,3.9,0,0,0-3.89,3.89v7.79a3.9,3.9,0,0,1-3.89,3.89H84.75a10.88,10.88,0,0,1-6.65-2.75L68,566.32a10.88,10.88,0,0,0-6.65-2.75H38a10.83,10.83,0,0,1-6.65-2.75L21.32,550.75a10.83,10.83,0,0,1-2.75-6.64v-7.79a10.83,10.83,0,0,1,2.75-6.64l10.07-10.07A10.83,10.83,0,0,1,38,516.86H77a10.83,10.83,0,0,1,6.65,2.75l41.21,41.21a10.83,10.83,0,0,0,6.64,2.75h23.36a3.9,3.9,0,0,0,3.89-3.89v-7.79a3.9,3.9,0,0,0-3.89-3.89H131.46a10.83,10.83,0,0,1-6.64-2.75L83.61,504A10.78,10.78,0,0,0,77,501.29H69.18a3.91,3.91,0,0,1-3.89-3.9v-7.78a3.91,3.91,0,0,1,3.89-3.9h38.93a10.78,10.78,0,0,1,6.64,2.76l25.64,25.63a10.79,10.79,0,0,0,6.65,2.76h7.78a3.9,3.9,0,0,0,3.89-3.9v-7.78a3.9,3.9,0,0,0-3.89-3.89H147a10.79,10.79,0,0,1-6.65-2.76L114.75,472.9a10.78,10.78,0,0,0-6.64-2.76h-7.79a3.9,3.9,0,0,1-3.89-3.89v-7.79a3.9,3.9,0,0,1,3.89-3.89h23.36c2.14,0,2.65-1.24,1.14-2.75l-10.07-10.07a10.83,10.83,0,0,1-2.75-6.64v-7.79a3.9,3.9,0,0,1,3.89-3.89h7.79a10.83,10.83,0,0,0,6.64-2.75l44-44Z"/>
					</g>
					<g className="SEHlocatie"
						onMouseOver={this.handleMouseMove}
						onMouseLeave={this.handleMouseLeave}
						onClick={this.handleMouseMove}
						>
						<g>
							<g><circle cx="405.28" cy="622.86" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6001" cx="405.28" cy="622.86" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="483.58" cy="593.1" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5912" cx="483.58" cy="593.1" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="427.31" cy="698.54" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6162" cx="427.31" cy="698.54" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="457.31" cy="640.53" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6043" cx="457.31" cy="640.53" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="406.18" cy="738.48" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6229" cx="406.18" cy="738.48" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="450.73" cy="725.06" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6419" cx="450.73" cy="725.06" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="609.89" cy="132.89" r="3.89" /></g>
							<g opacity="0"><circle id="SEH9501" cx="609.89" cy="132.89" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="610.79" cy="96.43" r="3.89" /></g>
							<g opacity="0"><circle id="SEH9679" cx="610.79" cy="96.43" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="548.11" cy="93.15" r="3.89" /></g>
							<g opacity="0"><circle id="SEH9728" cx="548.11" cy="93.15" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="545.88" cy="80.11" r="3.89" /></g>
							<g opacity="0"><circle id="SEH9713" cx="545.88" cy="80.11" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="491.21" cy="384.31" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7207" cx="491.21" cy="384.31" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="577.85" cy="425.18" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7101" cx="577.85" cy="425.18" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="356.42" cy="448.29" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4002" cx="356.42" cy="448.29" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="426.55" cy="466.97" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6532" cx="426.55" cy="466.97" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="431.54" cy="468.34" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6525" cx="431.54" cy="468.34" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="387.8" cy="327.28" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3844" cx="387.8" cy="327.28" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="401.11" cy="413.45" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6716" cx="401.11" cy="413.45" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="503.13" cy="424.93" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7009" cx="503.13" cy="424.93" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="438.24" cy="417.97" r="3.89" /></g>
							<g opacity="0"><circle id="SEH6815" cx="438.24" cy="417.97" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="446.25" cy="367" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7334" cx="446.25" cy="367" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="394.73" cy="137.87" r="3.89" /></g>
							<g opacity="0"><circle id="SEH8601" cx="394.73" cy="137.87" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="470.9" cy="116.47" r="3.89" /></g>
							<g opacity="0"><circle id="SEH9202" cx="470.9" cy="116.47" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="419.26" cy="94.08" r="3.89" /></g>
							<g opacity="0"><circle id="SEH8934" cx="419.26" cy="94.08" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="438.06" cy="155.73" r="3.89" /></g>
							<g opacity="0"><circle id="SEH8441" cx="438.06" cy="155.73" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="322.34" cy="318.16" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1315" cx="322.34" cy="318.16" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="488.52" cy="228.63" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7943" cx="488.52" cy="228.63" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="522.93" cy="222.46" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7909" cx="522.93" cy="222.46" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="605.58" cy="203.76" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7824" cx="605.58" cy="203.76" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="544" cy="146.81" r="3.89" /></g>
							<g opacity="0"><circle id="SEH9401" cx="544" cy="146.81" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="202.98" cy="399.02" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2725" cx="202.98" cy="399.02" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="170.69" cy="389.26" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2597" cx="170.69" cy="389.26" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="162.87" cy="404.49" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2545" cx="162.87" cy="404.49" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="168.94" cy="398.23" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2512" cx="168.94" cy="398.23" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="198.52" cy="448.95" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3083" cx="198.52" cy="448.95" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="208.42" cy="451.73" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3079" cx="208.42" cy="451.73" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="192.56" cy="432.89" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3045" cx="192.56" cy="432.89" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="195.57" cy="442.3" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3015" cx="195.57" cy="442.3" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="209.37" cy="373.38" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2353" cx="209.37" cy="373.38" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="197.59" cy="371.97" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2333" cx="197.59" cy="371.97" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="234.31" cy="412.14" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2803" cx="234.31" cy="412.14" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="277.78" cy="463.69" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4204" cx="277.78" cy="463.69" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="230.95" cy="476.84" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3318" cx="230.95" cy="476.84" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="135.89" cy="482.11" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3247" cx="135.89" cy="482.11" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="174.61" cy="420.31" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2625" cx="174.61" cy="420.31" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="212.59" cy="436.36" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2906" cx="212.59" cy="436.36" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="88.93" cy="603.51" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4535" cx="88.93" cy="603.51" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="97.06" cy="555.02" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4462" cx="97.06" cy="555.02" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="311.64" cy="395.71" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3584" cx="311.64" cy="395.71" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="303.89" cy="397.45" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3582" cx="303.89" cy="397.45" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="293.24" cy="390.82" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3543" cx="293.24" cy="390.82" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="298.04" cy="413.34" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3435" cx="298.04" cy="413.34" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="350.85" cy="373.42" r="3.89" /></g>
							<g opacity="0"><circle id="SEH3813" cx="350.85" cy="373.42" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="472.87" cy="279.95" r="3.89" /></g>
							<g opacity="0"><circle id="SEH8025" cx="472.87" cy="279.95" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="558.17" cy="261.69" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7772" cx="558.17" cy="261.69" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="604.21" cy="358.62" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7512" cx="604.21" cy="358.62" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="482.23" cy="348.25" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7416" cx="482.23" cy="348.25" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="559.41" cy="325.93" r="3.89" /></g>
							<g opacity="0"><circle id="SEH7609" cx="559.41" cy="325.93" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="257.28" cy="297.38" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1502" cx="257.28" cy="297.38" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="278.37" cy="282.85" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1441" cx="278.37" cy="282.85" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="297.57" cy="243.04" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1624" cx="297.57" cy="243.04" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="316.05" cy="353.11" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1213" cx="316.05" cy="353.11" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="229.91" cy="332.84" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2134" cx="229.91" cy="332.84" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="229.41" cy="319.63" r="3.89" /></g>
							<g opacity="0"><circle id="SEH2035" cx="229.41" cy="319.63" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="245.93" cy="167.11" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1782" cx="245.93" cy="167.11" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="328.38" cy="343.49" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1261" cx="328.38" cy="343.49" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="228.11" cy="287.17" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1942" cx="228.11" cy="287.17" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="277.68" cy="330.89" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1105" cx="277.68" cy="330.89" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="271.61" cy="322.32" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1091" cx="271.61" cy="322.32" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="262.85" cy="329.85" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1081" cx="262.85" cy="329.85" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="259.25" cy="317.09" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1061" cx="259.25" cy="317.09" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="272.04" cy="308.17" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1034" cx="272.04" cy="308.17" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="242.71" cy="246.57" r="3.89" /></g>
							<g opacity="0"><circle id="SEH1815" cx="242.71" cy="246.57" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="352.49" cy="581.98" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5504" cx="352.49" cy="581.98" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="384.35" cy="510.71" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5406" cx="384.35" cy="510.71" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="300.63" cy="544.43" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5022" cx="300.63" cy="544.43" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="332.42" cy="503.34" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5223" cx="332.42" cy="503.34" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="188.92" cy="550.38" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4708" cx="188.92" cy="550.38" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="394.11" cy="562.07" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5707" cx="394.11" cy="562.07" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="379.99" cy="578.13" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5664" cx="379.99" cy="578.13" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="366.22" cy="566.91" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5623" cx="366.22" cy="566.91" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="248.35" cy="534.06" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4818" cx="248.35" cy="534.06" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="440.11" cy="508.22" r="3.89" /></g>
							<g opacity="0"><circle id="SEH5835" cx="440.11" cy="508.22" r="7.78" fill="#fff"/></g>
						</g>
						<g>
							<g><circle cx="166.39" cy="558.43" r="3.89" /></g>
							<g opacity="0"><circle id="SEH4624" cx="166.39" cy="558.43" r="7.78" fill="#fff"/></g>
						</g>
						<g id="legenda">
							<circle cx="9.75" cy="657" r="3.89" fill="#1d1d1b"/>
						</g>
					</g>
					<g className="legenda">
						<text transform="translate(21 663.12)">SEH-afdeling </text>
						<text transform="translate(82.74 762)">15</text>
						<text transform="translate(4.74 762)">0</text>
						<text transform="translate(168.74 762)">30</text>
						<text transform="translate(253.74 762)">45</text>
						<text transform="translate(291 762)">minuten</text>
						<rect x="6" y="708" width="342" height="30"/>
					</g>
				</svg>

				<div className="vis-credit">
					<p>Rijtijd per auto naar de meest nabije SEH-afdeling in 2019</p>
					<p>Bron: RIVM, 2020.</p>
				</div>

				<div style={tooltipStyle} >
					{tooltip.text}
				</div>

			</div>
		);
	}
}

export default RijtijdSEH;


